'use client';

import { useEffect, useRef } from 'react';

export interface KwizlyWidgetProps {
  embedId: string;
}

export const KwizlyWidget = ({ embedId }: KwizlyWidgetProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const script = document.createElement('script');
      script.src = `https://kwizly.com/embed/${embedId}.js`;
      script.defer = true;
      script.type = 'text/javascript';
      script.onload = () => console.log('Script loaded successfully');
      script.onerror = () => console.error('Failed to load the script');

      document.getElementById(embedId)?.appendChild(script);

      return () => {
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    }
  }, [embedId]);

  return (
    <>
      <div data-nosnippet className={`kwizly-quiz kwizly-${embedId}`} />

      <div id={embedId} ref={containerRef} />
    </>
  );
};
